import { useEffect, useRef } from "react";
import { coverSrc } from "./api";

// Lock-screen / control-center metadata and buttons (play, pause, previous, next, seek).
export const useMediaSession = (mix, { audioRef, toggle, step, seek, time, duration }) => {
  const handlers = useRef({});
  handlers.current = { toggle, step, seek };
  const ms = typeof navigator !== "undefined" ? navigator.mediaSession : null;

  useEffect(() => {
    if (!ms || !mix) return undefined;
    const art = coverSrc(mix.cover_url);
    const abs = art ? new URL(art, window.location.origin).href : `${window.location.origin}/favicon.png`;
    ms.metadata = new window.MediaMetadata({
      title: mix.title, artist: "DJ T-REX", album: mix.genre || "DJ T-REX",
      artwork: [{ src: abs, sizes: "512x512", type: "image/jpeg" }],
    });
    const set = (action, fn) => { try { ms.setActionHandler(action, fn); } catch (e) { /* unsupported action */ } };
    const a = audioRef.current;
    set("play", () => a.play().catch(() => {}));
    set("pause", () => a.pause());
    set("previoustrack", () => handlers.current.step(-1));
    set("nexttrack", () => handlers.current.step(1));
    set("seekto", (d) => handlers.current.seek(d.seekTime));
    set("seekbackward", (d) => handlers.current.seek(Math.max(0, a.currentTime - (d.seekOffset || 10))));
    set("seekforward", (d) => handlers.current.seek(a.currentTime + (d.seekOffset || 10)));
    return undefined;
  }, [ms, mix?.id, mix?.title, audioRef]); // eslint-disable-line react-hooks/exhaustive-deps

  const sec = Math.floor(time / 5);
  useEffect(() => {
    if (!ms?.setPositionState || !duration || !Number.isFinite(duration)) return undefined;
    try { ms.setPositionState({ duration, position: Math.min(time, duration), playbackRate: 1 }); } catch (e) { /* ignore */ }
    return undefined;
  }, [ms, sec, duration]); // eslint-disable-line react-hooks/exhaustive-deps
};
